import { Grid, FormControlLabel, Checkbox, Typography } from '@mui/material';
import { de } from 'date-fns/locale';

const TabFourteen = ({
  setEmployeeOnboardingData,
  employeeOnboardingData,
  onboardingToDoListData,
  setOnboardingToDoListData,
  onClickAll,
  isEdit
}) => {
  console.log(employeeOnboardingData, 'employeeOnboardingData');
  console.log(onboardingToDoListData, 'onboardingToDoListData');
  const employeeData = Array.isArray(employeeOnboardingData)
    ? employeeOnboardingData
    : [];

  const todoData = Array.isArray(onboardingToDoListData)
    ? onboardingToDoListData
    : [];
  return (
    <>
      <Grid container>
        <Grid item xs={12} sx={{ mt: 1 }}>
          <Typography sx={{ pt: 2 }} variant="h5">
            Employee Onboarding
          </Typography>
        </Grid>
        <Grid item xs={12} sx={{ mt: 1 }}>
          <FormControlLabel
            id="employee-onboarding-form-all"
            control={
              <Checkbox
                id="employee-onboarding-all"
                checked={employeeData.every((dash) => dash.value)}
                onClick={(e) => onClickAll(employeeData, 'common', setEmployeeOnboardingData, e)}
                disabled={isEdit}
              />
            }
            label="All"
          />
        </Grid>
        {employeeData.slice().sort((a, b) => a.id - b.id).map((data, index) =>  {
          return (
            <Grid item xs={4}>
              <FormControlLabel
                  control={
                    <Checkbox
                      disabled={isEdit}
                      checked={employeeData[index]?.value}
                      onChange={(e) => {
                        let items = [...employeeData];
                        let item = { ...items[index] };
                        item = {
                          id: data.id,
                          name: data.name,
                          tab: data.tab,
                          value: !data.value
                        };
                        items[index] = item;
                        setEmployeeOnboardingData(items);
                      }}
                    />
                  }
                  label={data.name}
                />
            </Grid>
          );
        })}
      
      </Grid>

    <Grid container>
      <Grid item xs={12} sx={{ mt: 1 }}>
        <Typography sx={{ pt: 2 }} variant="h5">
          Onboarding To Do List
        </Typography>
      </Grid>
      <Grid item xs={12} sx={{ mt: 1 }}>
        <FormControlLabel
          id="onboarding-to-do-list-form-all"
          control={
            <Checkbox
              id="onboarding-to-do-list-all"
              checked={todoData.every((dash) => dash.value)}
              onClick={(e) => onClickAll(todoData, 'common', setOnboardingToDoListData, e)}
              disabled={isEdit}
            />
          }
          label="All"
        />
      </Grid>
      {todoData.slice().sort((a, b) => a.id - b.id).map((data, index) =>  {
        return (
          <Grid item xs={4}>
             <FormControlLabel
                control={
                  <Checkbox
                    disabled={isEdit}
                    checked={todoData[index]?.value}
                    onChange={(e) => {
                      let items = [...todoData];
                      let item = { ...items[index] };
                      item = {
                        id: data.id,
                        name: data.name,
                        tab: data.tab,
                        value: !data.value
                      };
                      items[index] = item;
                      setOnboardingToDoListData(items);
                    }}
                  />
                }
                label={data.name}
              />
          </Grid>
        );
      })}
     
    </Grid>
    </>
  );
};

export default TabFourteen;
